import {useContext} from "react";
import UserContext from "./UserContext";

export const SameHostHyperlink = ({ to, params, children, hyperlinkStyle=true, ...props }) => {
    const {loginString} = useContext(UserContext);

    const clickHref = window.location.origin + to + loginString + (params ? '&' + params : '');
    const copyHref = window.location.origin + to + (params ? '?' + params : '');

    const handleClick = (e) => {
        // console.log('clickHref', clickHref);
        // console.log('copyHref', copyHref);
        window.open(clickHref, '_blank', 'noopener,noreferrer');
        e.stopPropagation()
    }

    return (
        <div onClick={handleClick}>
            <a className={ hyperlinkStyle ? 'hyperlink' : ''}
               href={copyHref}
               onClick={e => {e.preventDefault()}}
               {...props}
            >
                {children}
            </a>
        </div>
    );
}